import { Calendar } from "antd";
import styled from "styled-components";
import { theme } from "../../../../theme";

const CalendarHeaderTypo = styled.div`
  ${theme.typo.heading.b20};
`;

const CustomCalendar = styled(Calendar)`
  & .ant-picker-panel {
    border: none;

    & thead > tr > th {
      ${theme.typo.body.r16};
      color: ${theme.colors.gray1};
      &:nth-child(1) {
        color: red;
      }
      &:nth-child(7n) {
        color: blue;
      }
    }
  }

  & .ant-picker-cell-disabled {
    &::before {
      background-color: transparent;
    }
    & > div {
      color: ${theme.colors.gray6} !important;
      & * {
        fill: ${theme.colors.gray6} !important;
      }
    }
  }

  & .ant-picker-cell-today {
    & > div {
      &::before {
        border: none !important;
      }
    }
  }
`;

const DateBox = styled.div`
  position: relative;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 48px;
  width: 100%;

  .ant-picker-cell-selected & {
    background: ${theme.colors.mainPrimary9} !important;
    &:not(.color) {
      color: ${theme.colors.gray1} !important;
    }
  }
`;

const Days = styled.div`
  ${theme.typo.body.r14};
`;

const HolidayName = styled.div`
  ${theme.typo.body.r12};

  font-size: 11px;
  line-height: 11px;
  white-space: nowrap;
`;

export { CalendarHeaderTypo, CustomCalendar, DateBox, Days, HolidayName };
